package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.jetbrains.compose.web.css.cssRem
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.libraries.CoroutinesSample
import org.moxultimate.topwithmox.libraries.FlowSample
import org.moxultimate.topwithmox.libraries.SilkFoundationSample
import org.moxultimate.topwithmox.libraries.SilkIconsSample

@InitRoute
fun initPreviewRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Preview"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun PreviewRoute() {
    Column(Modifier.gap(2.cssRem).padding(2.cssRem)) {
        FlowSample()
        CoroutinesSample()
        SilkIconsSample()
        SilkFoundationSample()
        // add any component here
    }
}
